// extracted by mini-css-extract-plugin
export default {"root":"LoadingFullpage_root__yk3LD","logo":"LoadingFullpage_logo__Yhr64"};